var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEggs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9448 25.3333C36.4871 25.3333 39.9707 28.4864 41.8893 33.389C40.1412 34.3181 38.5232 35.4949 37.2021 36.822C32.3288 41.7264 31.1442 48.6073 34.2817 53.1275C33.8361 53.2026 33.3893 53.2532 32.9448 53.2532C27.2764 53.2531 22.6641 47.4176 22.6641 40.2454C22.6641 33.3505 27.1551 25.3333 32.9448 25.3333Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6447 53.6395C32.2858 49.4503 33.4551 42.6664 38.2377 37.8559C39.5788 36.5061 41.2385 35.3082 43.0393 34.3937L43.2 34.3115L43.162 34.2352C45.5404 33.0534 48.1025 32.3999 50.3972 32.3999C52.7728 32.3999 54.7465 33.1132 56.1046 34.4638C57.9969 36.3447 58.6482 39.3659 57.9349 42.9705C57.2519 46.4292 55.4116 49.8729 52.8842 52.4147C50.0382 55.2779 46.3665 56.9194 42.8107 56.9194C40.2112 56.9194 37.9585 56.046 36.2953 54.392C36.1244 54.2241 35.9592 54.0301 35.7922 53.83L35.6447 53.6395Z",
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEggs);
export default __webpack_public_path__ + "static/media/eggs.26c2ebd8cc41b565316e0e06c7e8bd00.svg";
export { ForwardRef as ReactComponent };